import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import GASendMultiScreenPage from 'apps/auth/pages/ga/GASendMultiScreenPage';
import GaSendSelectCountryPage from 'apps/auth/pages/ga/GaSendSelectCountryPage';
import GaStatusPage from 'apps/auth/pages/ga/GaStatusPage';
import DeliveryOptionsPage from 'apps/auth/pages/send/DeliveryOptionsPage';
const gaSend = [
    {
        path: ['/auth/ga/pay/status/request'],
        component: GaStatusPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: ['/auth/ga/pocket/:pocketId/send/:countryCodeA2/:currencyIso/:deliveryMethod'],
        component: GASendMultiScreenPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: ['/auth/ga/pocket/:pocketId/send/repeat/:repeatId/CONTACT', '/auth/ga/pocket/:pocketId/send/gt/repeat/:repeatId'],
        component: GASendMultiScreenPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
            repeat: true,
        },
    },
    {
        path: '/auth/ga/pocket/:pocketId/send/:countryCodeA2/delivery',
        component: DeliveryOptionsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:pocketId/send',
        component: GaSendSelectCountryPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
];

export default gaSend;
